import React from "react";

export const Kpi = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={28} height={16} rx={1} fill="#F1F2F6" />

    <polyline
      points="3 12 9 8 14 12 25 4"
      fill="none"
      stroke="#0787C9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </g>
);
